import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { routes } from './app.routes';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { isDevMode } from '@angular/core';
import { geoReducer } from './geo/reducer/geo.reducer';
import { GeoEffects } from './geo/effect/geo.effects';
import {BlogService} from "./blog/ng-store/service/blog.service";
import { MarkdownModule, MarkedOptions, MARKED_OPTIONS, MERMAID_OPTIONS } from 'ngx-markdown';
import { ClipboardModule } from 'ngx-clipboard';
import { Renderer } from 'marked';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';

// Custom marked options factory with secure link handling
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new Renderer();

  renderer.link = ({ href, title, tokens }) => {
    var prot;
    try {
      prot = decodeURIComponent(unescape(href as string))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (prot.indexOf('javascript:') === 0) {
      return '';
    }

    // Extract text from tokens
    const text = tokens.map(token => {
      if ('text' in token) return token.text;
      if ('raw' in token) return token.raw;
      return '';
    }).join('');

    var out = '<a href="' + href + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += ' rel="nofollow" target="_blank">' + text + '</a>';
    return out;
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore({
      geo: geoReducer
    }),
    provideEffects([GeoEffects]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75
    }),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(),
    provideAnimations(),
    provideClientHydration(withHttpTransferCacheOptions({
      includePostRequests: true
    })),
    importProvidersFrom(MarkdownModule.forRoot({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useFactory: markedOptionsFactory,
      },
      mermaidOptions: {
        provide: MERMAID_OPTIONS,
        useValue: {
          darkMode: true,
          look: 'handDrawn',
        },
      },
    })),
    importProvidersFrom(ClipboardModule),
    importProvidersFrom(NgcCookieConsentModule.forRoot({
      cookie: {
        domain: 'localhost', // Use localhost for development, change to your domain in production
      },
      position: 'bottom',
      theme: 'classic',
      palette: {
        popup: {
          background: '#000',
          text: '#fff'
        },
        button: {
          background: '#f1d600',
          text: '#000'
        }
      },
      type: 'opt-in', // Most compliant - requires explicit consent
      content: {
        message: 'This website uses cookies to ensure you get the best experience on our website.',
        dismiss: 'Got it!',
        deny: 'Refuse cookies',
        link: 'Learn more',
        href: 'https://cookiesandyou.com',
        policy: 'Cookie Policy'
      },
      law: {
        regionalLaw: false,
      },
      location: false
    })),
    ],
};
